/* eslint-disable */
// @ts-nocheck

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import LoadingSpin from './LoadingSpin'

interface AlertInterface {
  title: string
  text: string
  onAction: Function
  onCancel: Function
  loading?: boolean
}

const AlertContainer = ({
  title,
  text,
  onAction,
  onCancel,
  loading,
}: AlertInterface) => {
  return (
    <>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            aria-hidden="true"
            className="h-6 w-6 text-red-600"
          />
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            {title}
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">{text}</p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <button
          className="inline-flex w-full justify-center gap-1 rounded-md border border-transparent bg-red-600 px-2 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 hover:bg-red-700 sm:ml-3 sm:w-auto sm:text-sm"
          disabled={loading}
          onClick={() => onAction()}
          type="button"
        >
          {loading && <LoadingSpin />}
          Continuar
        </button>
        <button
          className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
          onClick={() => onCancel(false)}
          type="button"
        >
          {' '}
          Cancelar
        </button>
      </div>
    </>
  )
}

export default AlertContainer
